import { jumpTo } from '@/common/utils'

const Toast = Mach.requireModule('Toast')
const SLCommon = Mach.requireModule('SLCommon')

export const jumpToHome = () =>
  jumpTo({
    urlInfo: {
      url: 'sailorc://keeta.com/home?businessType=market',
    },
  })

export const handleError = (err: { message: string }) => {
  if (err && err.message) {
    Toast.show(err.message, 2)
  }
}

export const copyText = (options: { content?: string; successDescription?: string }) => {
  let { content, successDescription } = options
  if (Mach.env.isAndroid) {
    const { deviceModel, osVersion } = Mach.env
    if (!!deviceModel && !!osVersion && typeof deviceModel === 'string' && typeof osVersion === 'string' && deviceModel.indexOf('samsung@') === 0) {
      // 三星13及以上的系统，当 copy 文案的时候会有一个系统自动 toast
      // 三星的版本: 33_13, 需要提取 _ 后面的数字 [13], 如果这个数字大于等于 13, 那就直接不传提醒文案
      const versions = osVersion.split('_')
      if (!!versions && versions.length > 0) {
        const version = parseFloat(versions[versions.length - 1])
        if (version >= 13) {
          // 不传提醒文案
          successDescription = ''
        }
      }
    }
  }
  SLCommon.copyText({
    content,
    successDescription,
  })
}
